import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      WELCOME_BACK: "Velkommen!",
      YOU_HAVE_BEEN_GONE_FOR_A_WHILE:
        "Det ser ut som du har vært borte en stund.",
      REACTIVATE_TO_SEE_DISHES:
        "Reaktiver abonnementet ditt for å se dine retter.",
      WE_ARE_PREPARING_YOUR_MENU: "Vi klargjør din meny",
      SORTING_INGREDIENTS: "Sorterer råvarer...",
      CALCULATING_CALORIES_0: "Beregner kalorier...",
      CALCULATING_CALORIES_1: "Balanserer næringsinnhold...",
      PUTTING_TOGETHER_MENU_0: "Filterer oppskrifter...",
      PUTTING_TOGETHER_MENU_1: "Finner varierte retter...",
      PUTTING_TOGETHER_MENU_2: "Setter sammen din meny...",
    },
    se: {
      WELCOME_BACK: "Välkommen!",
      YOU_HAVE_BEEN_GONE_FOR_A_WHILE:
        "Det ser ut som du har varit borta ett tag.",
      REACTIVATE_TO_SEE_DISHES:
        "Återaktivera din prenumeration för att se dina rätter.",
      WE_ARE_PREPARING_YOUR_MENU: "Vi förbereder din meny",
      SORTING_INGREDIENTS: "Sorterar råvaror...",
      CALCULATING_CALORIES_0: "Beräknar kalorier...",
      CALCULATING_CALORIES_1: "Beräknar kalorier...",
      PUTTING_TOGETHER_MENU_0: "Sätter ihop din meny...",
      PUTTING_TOGETHER_MENU_1: "Sätter ihop din meny...",
      PUTTING_TOGETHER_MENU_2: "Sätter ihop din meny...",
    },
    dk: {
      WELCOME_BACK: "Velkommen!",
      YOU_HAVE_BEEN_GONE_FOR_A_WHILE:
        "Det ser ud til, at du har været væk i et stykke tid.",
      REACTIVATE_TO_SEE_DISHES:
        "Genaktivér dit abonnement for at se dine retter.",
      WE_ARE_PREPARING_YOUR_MENU: "Vi forbereder din menu",
      SORTING_INGREDIENTS: "Sorterer ingredienser...",
      CALCULATING_CALORIES_0: "Beregner kalorier...",
      CALCULATING_CALORIES_1: "Beregner kalorier...",
      PUTTING_TOGETHER_MENU_0: "Sætter din menu sammen...",
      PUTTING_TOGETHER_MENU_1: "Sætter din menu sammen...",
      PUTTING_TOGETHER_MENU_2: "Sætter din menu sammen...",
    },
  } as const
)[language];
